/* eslint-disable no-console */
// this lint is disabled because all logs are behind environment variable switches
import React from 'react';
import ConfirmationBox from '../Components/ConfirmationBox';
import MobileHeader from '../Components/MobileHeader';
import Question from '../Components/Question';
import ScreenNav from '../Components/ScreenNav';
import { apiService } from '../Services/summonsAPI';
import ErrorMessage from './ErrorMessage';

const CONSOLE_DEBUG = process.env.REACT_APP_ENVIRONMENT_NAME !== 'PRODUCTION';
const debugLog = (...etc) => {
    if (CONSOLE_DEBUG) console.log(...etc);
};
const debugWarn = (...etc) => {
    if (CONSOLE_DEBUG) console.warn(...etc);
};

const SAVE_PROGRESS_ON_NEXT_BUTTON = true;

// this is meant to allow maintenance of answers without different outcomes.
const ALL_QUESTIONS_ON_ONE_SCREEN = false;

export default class Questionnaire extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            questionnaire: { questions: [], apiError: null, errorMessage: '' },
            screenIdx: 0,
            screens: [[]],
            screenByQuestionId: {},
            assertedOutcome: false,
            debouncePost: 0,
            errorTexts: {},
            disables: {}
        };
        this.inputUpdateQuestionResponse = this.inputUpdateQuestionResponse.bind(this);
        this.validateWholeScreen = this.validateWholeScreen.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.inputNext = this.inputNext.bind(this);
        this.inputCancelQuestionnaire = this.inputCancelQuestionnaire.bind(this);
        this.inputSubmitQuestionnaire = this.inputSubmitQuestionnaire.bind(this);
    }

    async componentDidMount() {
        try {
            const data = await (
                await apiService.getQuestionnaire(this.props.jurorID).catch((err) => {
                    debugLog(err);
                    const msgs = {
                        AbortError: 'Request timed out',
                        Unknown: 'Unknown error'
                    };
                    return new Response(
                        JSON.stringify({
                            apiError: err.name,
                            errorMessage: msgs[err.name] || msgs.Unknown
                        })
                    );
                })
            ).json();

            this.setState({ questionnaire: data });
            this.makeScreens();
            this.validateWholeScreen();

            // debugLog('data loaded');
        } catch (e) {
            this.setState({ error: e.message });
        }
    }

    componentWillUnmount() {
        if (this.state.debouncePost) clearTimeout(this.state.debouncePost);
    }

    onLastScreen() {
        return this.state.screenIdx === this.state.screens.length - 1;
    }

    getQuestionById(questionId) {
        const a = this.state.questionnaire.questions.filter((q) => q.questionID === questionId);
        return a ? a[0] : null;
    }

    getQuestionByAlias(alias) {
        const a = this.state.questionnaire.questions.filter((q) => q.alias === alias);
        return a ? a[0] : null;
    }

    /** * helper function for input validation ** */
    getResponse(q) {
        const type = q.answerType.answerTypeAlias;
        let response = null;
        switch (type) {
            /** * Allow validation rule from backend to test if equal to some choice's text rather its ID  ** */
            case 'Picklist' /** * This could maybe be done to Choice as well ** */:
                /// case 'Choice':
                response = q.answers.filter((a) => a.questionnaireAnswerID === q.response.questionnaireAnswerID);
                if (response.length) return response[0].label;

            // eslint-disable-next-line no-fallthrough
            default:
                response = q.response[type === 'Choice' ? 'questionnaireAnswerID' : 'responseText'];
        }
        return this.respondedHow({ type: type, response: response });
    }

    printState = async () => {
        console.log(this.state);
    };

    inputUpdateQuestionResponse(id, resp) {
        // set state here, then save on logout
        this.state.questionnaire.questions.forEach((q, idx) => {
            if (q.questionID === id) {
                const { questionnaire } = this.state;
                if (q.answerType.answerTypeAlias === 'Choice' || q.answerType.answerTypeAlias === 'Picklist') {
                    questionnaire.questions[idx].response.questionnaireAnswerID = resp ? parseInt(resp) : null;
                } else {
                    questionnaire.questions[idx].response.responseText = resp;
                }
                this.setState({ questionnaire: questionnaire });
            }
        });
    }

    /** * helper function to inputUpdateQuestionResponse, formats responses for backend ** */
    respondedHow(answer) {
        const b = answer.response;
        switch (answer.type) {
            case 'TextOnly':
                return 'true';
            case 'Checkbox':
                if (typeof b === 'string' && b.length) return b;
                return '0';
            case 'YesNo':
                if (b === '1') return b;
                if (b === '0') return b;
                return '?';
            case 'Choice':
            case 'Picklist':
            case 'Integer':
            case 'Number':
            case 'PhoneNumber':
            case 'TextEntry':
                if (typeof b === 'string' && b.match(/^[\W_]*$/)) return '?';
                if (b === null || b === undefined) return '?';
                return `${b}`;
            default:
                return '?';
        }
    }

    async saveSignature(signature) {
        let postResult;
        try {
            postResult = await (
                await apiService.postJurorSignature({ jurorId: this.props.jurorID, signature: signature }).catch((err) => {
                    debugWarn(err);
                    const msgs = {
                        AbortError: 'Request timed out',
                        Unknown: 'Unknown error'
                    };
                    return new Response(
                        JSON.stringify({
                            apiError: err.name,
                            errorMessage: msgs[err.name] || msgs.Unknown
                        })
                    );
                })
            ).json();
        } catch (e) {
            await this.setState({ error: e.message });
        }

        debugLog('postJurorSignature', postResult);
        return postResult;
    }

    async saveProgress(immediate) {
        const actuallyPost = async () => {
            const postBody = JSON.stringify(this.state.questionnaire);
            debugLog(postBody);

            let postResult;
            try {
                postResult = await (
                    await apiService.postQuestionnaire(this.state.questionnaire).catch((err) => {
                        debugWarn(err);
                        const msgs = {
                            AbortError: 'Request timed out',
                            Unknown: 'Unknown error'
                        };
                        return new Response(
                            JSON.stringify({
                                apiError: err.name,
                                errorMessage: msgs[err.name] || msgs.Unknown
                            })
                        );
                    })
                ).json();
            } catch (e) {
                await this.setState({ error: e.message });
            }

            debugLog('postQuestionnaire result', postResult);
            return postResult;
        };
        if (this.state.debouncePost) clearTimeout(this.state.debouncePost);
        if (immediate) return actuallyPost();
        else this.setState({ debouncePost: setTimeout(actuallyPost, 2345) });
        return null;
    }

    async makeScreens() {
        // A group contains one or more question IDs
        const groups = [];
        let group = [];
        // reverse lookup table
        const screenByQuestionId = {};
        // Collect question IDs per screenful
        let lastGroupId = -1;
        let groupId = 1;
        this.state.questionnaire.questions.forEach((q) => {
            if (!ALL_QUESTIONS_ON_ONE_SCREEN) groupId = q.questionGroup ? q.questionGroup.questionGroupID : 0;
            if (!groupId || groupId !== lastGroupId) {
                if (group.length) groups.push(group);
                group = [];
            }
            group.push(q.questionID);
            lastGroupId = groupId;
        });
        if (group.length) groups.push(group);

        groups.forEach((grp, gidx) => {
            grp.forEach((qid) => {
                screenByQuestionId[qid] = gidx;
            });
        });
        this.setState({
            screens: groups,
            screenByQuestionId: screenByQuestionId,
            dataLoaded: true
        });
    }

    /** * return false if user cannot leave the screen going forward (next) ** */
    /** * helper function to inputNext(), which is in turn bound to next button ** */
    /** * determines if you can press next or not ** */
    whereToNext() {
        /** * questions presented to the user up until this point ** */
        const questions = this.state.questionnaire.questions.filter((q) => this.state.screenByQuestionId[q.questionID] <= this.state.screenIdx);
        if (!questions.length) return;
        const valids = {};
        let doDefer;

        // Test to see if the question is a followup to a previously presented question.
        //
        // A question may only have one parent question, and the test against a parent
        // is fairly basic in the way of less than some number, greater than some number,
        // or equal to some value (as a string)
        //
        questions.forEach((q) => {
            const resp = this.getResponse(q);
            if (doDefer === undefined && resp === q.defermentValue) {
                doDefer = q.defermentCodeID;
            }

            if (!q.questionValidations) {
                /** * not sure why this happens. database not properly defined maybe ** */
                debugLog('questionValidationNotFound?', q);
                return;
            }
            if (!q.questionValidations.length) return;

            const perValidation = (validationRule) => {
                const { parentQuestionID, parentValueTest, childRequiresResponse } = validationRule;
                if (parentValueTest) {
                    const parentResp = parentQuestionID ? this.getResponse(this.getQuestionById(parentQuestionID)) : false;

                    const m = parentValueTest.match(/^([<=>!][=>]?)(.+)/);
                    if (m) {
                        const test = {
                            '<': (x) => parseInt(x) < parseInt(m[2]),
                            '>': (x) => parseInt(x) > parseInt(m[2]),
                            '=': (x) => x === m[2],
                            '!=': (x) => x !== m[2],
                            '<>': (x) => x !== m[2]
                        }[m[1]];
                        if (test) {
                            const testPassed = parentResp ? test(parentResp) : false;

                            if (testPassed) {
                                if (childRequiresResponse) {
                                    return resp === '?' ? false : resp;
                                } else {
                                    return true;
                                }
                            } else {
                                // followup qn is n/a
                                return true;
                            }
                        }
                    }
                }
                if (childRequiresResponse) {
                    return resp === '?' ? false : resp;
                } else {
                    return true;
                }
            };

            q.questionValidations.forEach((val) => {
                if (valids[q.questionID] == null) valids[q.questionID] = [];
                valids[q.questionID].push(perValidation(val));
            });
        });

        if (!Object.values(valids).every((arr) => Object.values(arr).every((x) => (typeof x === 'string' ? true : x)))) return;

        // if there is any red invalidation text, you shall not pass
        if (questions.map((q) => this.state.errorTexts[q.questionID]).some((x) => x)) return;

        const ret = {
            defermentCodeID: doDefer,
            message: doDefer !== undefined ? 'Based on your responses, you may qualify for a deferment.' : ''
        };

        // eslint-disable-next-line consistent-return
        return ret;
    }

    changeScreen(delta) {
        if (delta === -1) this.mouseBack = false;
        this.setState({
            screenIdx: Math.min(Math.max(0, this.state.screenIdx + delta), this.state.screens.length - 1)
        });
    }

    // bound to next button
    inputNext() {
        this.mouseNext = false;

        if (SAVE_PROGRESS_ON_NEXT_BUTTON) this.saveProgress();
        const where = this.whereToNext();

        // do nothing if user failed to answer questions satisfactorily
        if (!where) return;

        // pending outcome: prompt for a deferment
        if (where.defermentCodeID !== undefined) {
            this.setState({
                assertedOutcome: {
                    outcome: where.defermentCodeID,
                    message: where.message
                }
            });
            return;
        }

        // pending outcome: prompt for questionnaire completion
        if (this.onLastScreen()) {
            this.setState({
                assertedOutcome: {
                    outcome: true,
                    message: where.message
                }
            });
            return;
        }

        this.changeScreen(1);
    }

    inputCancelQuestionnaire() {
        this.setState({ assertedOutcome: false });
    }

    inputSubmitQuestionnaire(signature) {
        if (!this.state.assertedOutcome) return;
        if (!this.saveSignature(signature)) return;
        if (!this.saveProgress('immediate')) return;

        const { outcome } = this.state.assertedOutcome;
        const deferment = outcome === true ? null : outcome;
        this.props.dataReview(deferment ? 'possibleDeferment' : 'questionnaireComplete', deferment);
    }

    /** * validate the fields on the current screen or associated screen for a given question ID ** */
    validateWholeScreen(qid) {
        // re-evaluate rules for all questions on page
        const screenIdx = qid ? this.screenByQuestionId[qid] : this.state.screenIdx;
        let errs = this.state.screens[screenIdx].map((q) => this.validateInput(q));
        errs = this.state.questionnaire.questions.map((q) => this.validateInput(q.questionID));
        /** * return true if we have any errors for the responses on the screen ** */
        return Object.values(errs).some((x) => x);
    }

    /** *
     set errorText on a given question ID's response
     also whether or not question should be hidden/
     ** */
    validateInput(qid) {
        const q = this.getQuestionById(qid);
        if (!q) return;

        let errorFound = false;
        if (q.questionValidation && q.questionValidations.length) {
            const childResp = this.getResponse(q);
            const perValidationError = (validationRule) => {
                const {
                    parentQuestionID,
                    parentValueTest,
                    childRequiresResponse,
                    childDisallowedResponse,
                    childMatchRegEx,
                    errorMessage,
                    childNoMatchRegEx
                } = validationRule;

                let validationApplicable = true;
                let parentResp;
                if (parentValueTest) {
                    parentResp = parentQuestionID ? this.getResponse(this.getQuestionById(parentQuestionID)) : false;

                    const m = parentValueTest.match(/^([<=>!][=>]?)(.+)/);
                    if (m) {
                        const test = {
                            '<': (x) => parseInt(x) < parseInt(m[2]),
                            '>': (x) => parseInt(x) > parseInt(m[2]),
                            '=': (x) => x === m[2],
                            '!=': (x) => x !== m[2],
                            '<>': (x) => x !== m[2]
                        }[m[1]];
                        if (test) validationApplicable = parentResp ? test(parentResp) : false;
                    }
                }

                if (!validationApplicable) return {};

                if (childResp === '?') {
                    if (childRequiresResponse) return { errorText: 'Response required' };
                    else return {};
                }

                if (childDisallowedResponse) {
                    // unanswer the child question so we don't record potentially contradictory responses in the db
                    this.state.questionnaire.questions.forEach((quest, idx) => {
                        if (quest.questionID === qid) {
                            const qnaire = this.state.questionnaire;
                            qnaire.questions[idx].response.questionnaireAnswerID = null;
                            qnaire.questions[idx].response.responseText = null;
                            this.setState({ questionnaire: qnaire });
                        }
                    });

                    return { disabled: true };
                }

                /** * unpickle backend strings into actual RegExp objects ** */
                const match = (haystackStr, needleStr) => {
                    const mat = needleStr.match(/^\/(.+)\/(.*)$/);
                    return mat && haystackStr.match(new RegExp(mat[1], mat[2]));
                };

                if (childMatchRegEx && !childNoMatchRegEx) {
                    /** * if child response matches accept pattern ** */
                    return { errorText: match(childResp, childMatchRegEx) ? errorMessage : '' };
                } else if (!childMatchRegEx && childNoMatchRegEx) {
                    /** * if child response doesn't match deny pattern ** */
                    return { errorText: !match(childResp, childNoMatchRegEx) ? errorMessage : '' };
                }

                return {};
            };

            /** *
            Short-circuit OR these validation rules, that is,
            as soon as we encounter an applicable rule with an error message, we can end there
            ** */
            q.questionValidations.forEach((val) => {
                if (!errorFound) {
                    const res = perValidationError(val);

                    const errorsCopy = this.state.errorTexts;
                    errorsCopy[qid] = res.errorText ? res.errorText : '';
                    this.setState({ errorTexts: errorsCopy });

                    const disablesCopy = this.state.disables;
                    disablesCopy[qid] = res.disabled;
                    this.setState({ disables: disablesCopy });

                    errorFound = res.errorText;
                }
            });
        }

        if (!errorFound) this.customValidate(q);
    }

    customValidate(question) {
        const questionAlias = question.alias;
        let errorText = '';
        const response = this.getResponse(question).replace(/ /g, '');
        const MAX_AGE = 99;

        if (questionAlias === 'childAges' || questionAlias === 'stepChildAges') {
            let parentQuestionAlias;
            switch (questionAlias) {
                case 'childAges':
                    parentQuestionAlias = 'numChildren';
                    break;
                case 'stepChildAges':
                    parentQuestionAlias = 'numStepChildren';
                    break;
                default:
            }
            const parentQuestion = this.getQuestionByAlias(parentQuestionAlias);

            const parentResponse = this.getResponse(parentQuestion);
            const numChildren = parseInt(parentResponse);
            /* eslint-disable-next-line no-restricted-globals */
            if (!isNaN(numChildren) && numChildren > 0) {
                const ages = response.split(',');
                if (ages.length !== numChildren) {
                    errorText = 'Enter age required for each child.';
                } else {
                    for (let ageIdx = 0; ageIdx < numChildren; ageIdx += 1) {
                        const age = parseInt(ages[ageIdx]);
                        if (MAX_AGE < age) {
                            errorText = `Age of ${age} is not allowed.`;
                            break;
                        }
                    }
                }
            }
        }

        if (questionAlias === 'employerHowLong') {
            const howLong = parseInt(response);
            /* eslint-disable-next-line no-restricted-globals */
            if (!isNaN(howLong)) {
                if (MAX_AGE < howLong) {
                    errorText = `${howLong} years is not allowed.`;
                }
            }
        }

        const errorsCopy = this.state.errorTexts;
        errorsCopy[question.questionID] = errorText || '';
        this.setState({ errorTexts: errorsCopy });
    }

    render() {
        if (this.mouseBack) this.changeScreen(-1);
        if (this.mouseNext) this.inputNext();

        const page = (...etc) => [
            <MobileHeader
                key="mh"
                jurorName={this.props.jurorName}
                jurorID={this.props.jurorID}
                jurorReportingDateTime={this.props.jurorReportingDateTime}
                jurorStatus={this.props.jurorStatus}
                logOut={async () => {
                    await this.saveProgress('immediate');
                    this.props.logOut();
                }}
            />,
            <br />,
            ...etc
        ];

        let showErrorPage = this.state.error;
        if (showErrorPage) {
            debugLog(this.state.error);
        }
        const { apiError, errorMessage } = this.state.questionnaire;
        if (apiError) {
            showErrorPage = true;
            debugLog(apiError, errorMessage);
        } else if (this.state.screens && this.state.screens.length < 1) {
            showErrorPage = true;
            debugLog('unable to produce screens');
        }

        if (showErrorPage) {
            return (
                <ErrorMessage
                    jurorName={this.props.jurorName}
                    jurorID={this.props.jurorID}
                    jurorReportingDateTime={this.props.jurorReportingDateTime}
                    logOut={this.props.logOut}
                />
            );
        }

        if (!this.state.dataLoaded) return page(<p />);

        if (this.state.assertedOutcome) {
            return page(
                <ConfirmationBox
                    canSubmitAfter={3333}
                    message={[
                        this.state.assertedOutcome.message,
                        'By submitting this questionnaire, you certify that the responses made are true and correct.'
                    ]}
                    cancel={this.inputCancelQuestionnaire}
                    submit={this.inputSubmitQuestionnaire}
                    cancelText="Edit Responses"
                    submitText="Submit Responses"
                    className="questionnaire"
                />
            );
        }

        const qnaire = [];
        qnaire.push(
            <div style={{ padding: '2em' }} className="questionnaire">
                {this.state.screenIdx === 0 ? <p className="questionnaire-body">Please answer all questions.</p> : ''}

                <p style={{ opacity: 0.7 }}>{`Page ${this.state.screenIdx + 1} of ${this.state.screens.length}`}</p>
                {this.state.screens[this.state.screenIdx].map((qid) => (
                    <Question
                        disabled={this.state.disables[qid]}
                        errorText={this.state.errorTexts[qid]}
                        question={this.getQuestionById(qid)}
                        responseHandler={this.inputUpdateQuestionResponse}
                        validateFunction={() => {
                            this.validateWholeScreen();
                            /* entered a second time intentionally */
                            this.validateWholeScreen();
                        }}
                        questionnaire={this}
                    />
                ))}

                <ScreenNav
                    key="sn2"
                    previousAble={this.state.screenIdx !== 0}
                    previous={() => {
                        this.changeScreen(-1);
                    }}
                    questionnaire={this}
                    nextAble={this.whereToNext()}
                    next={this.inputNext}
                />
            </div>
        );

        if (CONSOLE_DEBUG)
            qnaire.push(
                <button key="dbgps" onClick={this.printState}>
                    printState
                </button>
            );

        return page(qnaire);
    }
}
